import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import nextIcon from './images/next-svgrepo-com.svg'


const FolioCard = ({ FolioInfos, animateRido, setRidoBG, setFolioTransition}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [myOpacity, setMyOpacity] = useState(1);

  const [FolioWidth, setFolioWidth] = useState("80%");
  const [FolioZoom, setFolioZoom] = useState("scale(1.0)");
  const [FolioScale, setFolioScale] = useState("scale(0.9)");
  const [FoliOpacity, setFoliOpacity] = useState("0.99");
  const [FolioBar, setFolioBar] = useState("-147px");
  const [FolioImgWidth, setFolioImgWidth] = useState("70%");
  const [FolioPadding, setFolioPadding] = useState("5%");

  const navigate = useNavigate();

  function timeout(delay: number) {
    return new Promise( res => setTimeout(res, delay) );
} 

  const goToPage = async () => {
    setRidoBG(FolioInfos.color)
    animateRido();
    await timeout(400);
    navigate(FolioInfos.link);
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      setFolioImgWidth("56%");
  
    };

    if (window.innerWidth > 600) {
      setFolioImgWidth("70%");
  
    };
  }, []); 
  


  const onHover = () =>{

    if (window.innerWidth > 600) {


      setFolioZoom("scale(1.05)");
      setFoliOpacity(".7");
      setFolioBar("-170px");
      setFolioImgWidth("90%")
      setFolioScale("scale(0.89)")
      setFolioPadding("4%")
      setFolioTransition(window.scrollY + window.innerHeight);
    }
    

  }

  const onLeave = () =>{

    if (window.innerWidth > 600) {
      setFolioZoom("scale(1.0)");
      setFoliOpacity(".99");
      setFolioBar("-155px");
      setFolioImgWidth("70%")
      setFolioScale("scale(0.9)")
      setFolioPadding("5%")
    }

  }


  const isLeft = FolioInfos.side === 'left';

  return (
    isLeft ? (
      
      <div className="folioCard" onClick={goToPage}  onMouseEnter = {onHover} onMouseLeave={onLeave} style={{  }}>
      {/*<div className="folioCard" onClick={goToPage}  onMouseEnter = {onHover} onMouseLeave={onLeave} style={{ width: FolioWidth }}>*/}

        <div className="folioImage" style={{'border-radius': '23px 0px 0px 23px',   width: FolioImgWidth}}>
                

                <div class="folioImageImg">

                    <img src={FolioInfos.image} alt={FolioInfos.title} style={{transform: FolioZoom, opacity: FoliOpacity}} />
                </div>

                
        </div>

    
        <div className="folioInfo" style={{padding: '3% 2% 2% 2%', transform: FolioScale}}>
            
          <div className="folioTitle">{FolioInfos.title}</div>
          <div className="shortLine" />
          <div className="folioRole">{FolioInfos.role}</div>
          <div className="folioDesc">{FolioInfos.desc}</div>
          <div className="folioTags">
            <div className="tag">{FolioInfos.tag1}</div>
            <div className="tag">{FolioInfos.tag2}</div>
            <div className="tag">{FolioInfos.tag3}</div>
          </div>
        </div>
        
      </div>
    ) : (
        <div className="folioCard" onClick={goToPage}  onMouseEnter = {onHover} onMouseLeave={onLeave} style={{ }}>
        

            <div className="folioInfo" style={{padding: '3% 2% 2% 2%', transform: FolioScale}}>
                <div className="folioTitle">{FolioInfos.title}</div>
                <div className="shortLine" />
                <div className="folioRole">{FolioInfos.role}</div>
                <div className="folioDesc">{FolioInfos.desc}</div>
                <div className="folioTags">
                    <div className="tag">{FolioInfos.tag1}</div>
                    <div className="tag">{FolioInfos.tag2}</div>
                    <div className="tag">{FolioInfos.tag3}</div>
                </div>
            </div>

            <div className="folioImage" style={{'border-radius': '0px 23px 23px  0px ',   width: FolioImgWidth}}>
                
                
                <div class="folioImageImg">

                    <img src={FolioInfos.image} alt={FolioInfos.title} style={{transform: FolioZoom, opacity: FoliOpacity}} />
                </div>

                {/*<div class="RightBar" style={{  'margin-left': FolioBar }}><img src={nextIcon}></img></div>*/}
                
            </div>


      </div>
    )
  );
};

export default FolioCard;
